module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": 'outline-primary'
    },
    on: {
      "click": function($event) {
        _vm.addContainerAllocation('Add', 0)
      }
    }
  }, [_vm._v(" Add")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.CAFNoFilter ||
        _vm.Filter.caf_transport_typeFilter ||
        _vm.Filter.caf_tpt_typeFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.driverFilter ||
        _vm.Filter.containerTypeFilter ||
        _vm.Filter.fromFilter ||
        _vm.Filter.toFilter ||
        _vm.Filter.billingForFilter ||
        _vm.Filter.CSTeamFilter ||
        _vm.Filter.contractNoFilter ||
        _vm.Filter.commodityHsnCodeFilter ||
        _vm.Filter.EMPFilter ||
        _vm.Filter.PORFilter ||
        _vm.Filter.POLFilter ||
        _vm.Filter.PODFilter ||
        _vm.Filter.FPODFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.updatedByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.createdAtRange.startDate ||
        _vm.Filter.createdAtRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.CAFNoFilter ||
    _vm.Filter.caf_transport_typeFilter ||
    _vm.Filter.caf_tpt_typeFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.driverFilter ||
    _vm.Filter.containerTypeFilter ||
    _vm.Filter.fromFilter ||
    _vm.Filter.toFilter ||
    _vm.Filter.billingForFilter ||
    _vm.Filter.CSTeamFilter ||
    _vm.Filter.contractNoFilter ||
    _vm.Filter.commodityHsnCodeFilter ||
    _vm.Filter.EMPFilter ||
    _vm.Filter.PORFilter ||
    _vm.Filter.POLFilter ||
    _vm.Filter.PODFilter ||
    _vm.Filter.FPODFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.updatedByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.createdAtRange.startDate ||
    _vm.Filter.createdAtRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getContainerAllocationList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getContainerAllocationList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  })], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdAtRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdAtRange", $$v)
      },
      expression: "Filter.createdAtRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("CAF NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search CAF NO Filter",
      "id": "CAFNoFilter",
      "name": "CAFNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.CAFNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "CAFNoFilter", $$v)
      },
      expression: "Filter.CAFNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transportation By")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.TPTtypeList,
      "id": "caf_tpt_typeFilter",
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select Transportation By"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.caf_tpt_typeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "caf_tpt_typeFilter", $$v)
      },
      expression: "Filter.caf_tpt_typeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Movement Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.movementTypeList,
      "id": "caf_transport_typeFilter",
      "option-value": "val",
      "option-text": "text",
      "placeholder": "Select Movement Type"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.caf_transport_typeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "caf_transport_typeFilter", $$v)
      },
      expression: "Filter.caf_transport_typeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.containerTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "containerTypeFilter", $$v)
      },
      expression: "Filter.containerTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("From")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select From"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.fromFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fromFilter", $$v)
      },
      expression: "Filter.fromFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "pTypeVal",
      "option-text": "pTypeText",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("To")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select To"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.toFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "toFilter", $$v)
      },
      expression: "Filter.toFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Driver Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllDriverDDList'],
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Driver Name"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.driverFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "driverFilter", $$v)
      },
      expression: "Filter.driverFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipper")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Shipper Name"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getContainerAllocation('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getContainerAllocationList,
      "fields": _vm.CafFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n                ")])]
      }
    }, {
      key: "CreatedDate",
      fn: function(row1) {
        return [_c('b-button', {
          staticClass: "pull-right ml-1 mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": 'outline-primary'
          },
          on: {
            "click": function($event) {
              _vm.addContainerAllocation('Edit', row1.item)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), (row1.item.caf_pdf_url) ? _c('b-button', {
          staticClass: "pull-right ml-1 mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": 'outline-warning'
          },
          on: {
            "click": function($event) {
              _vm.addContainerAllocation('View', row1.item)
            }
          }
        }, [_vm._v("View Doc")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dffc6b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/containerAllocationList.vue
// module id = 2774
// module chunks = 0